(function () {
  var prefersReducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var header = document.querySelector("[data-site-header]");
  var menuToggle = document.querySelector("[data-menu-toggle]");
  var mobileMenu = document.querySelector("[data-mobile-menu]");

  function setHeaderState() {
    if (!header) return;
    header.classList.toggle("is-scrolled", window.scrollY > 16);
  }

  setHeaderState();
  window.addEventListener("scroll", setHeaderState, { passive: true });

  if (header && menuToggle && mobileMenu) {
    menuToggle.addEventListener("click", function () {
      var open = header.classList.toggle("is-open");
      menuToggle.setAttribute("aria-expanded", String(open));
      menuToggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
    });

    mobileMenu.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function () {
        header.classList.remove("is-open");
        menuToggle.setAttribute("aria-expanded", "false");
        menuToggle.setAttribute("aria-label", "Open menu");
      });
    });
  }

  function initOriginalCore(canvas) {
    var ctx = canvas.getContext("2d", { alpha: true });
    var container = canvas.closest(".original-core") || canvas.parentElement;
    if (!ctx || !container) return;

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var width = 620;
    var height = 620;
    canvas.width = width * dpr;
    canvas.height = height * dpr;
    canvas.style.width = width + "px";
    canvas.style.height = height + "px";
    ctx.scale(dpr, dpr);

    var t = 0;
    var mouseX = 0.5;
    var mouseY = 0.5;
    var points = [];
    var connections = [];

    for (var i = 0; i < 68; i += 1) {
      var phi = Math.acos(-1 + (2 * i) / 68);
      var theta = Math.sqrt(68 * Math.PI) * phi;
      var x = Math.sin(phi) * Math.cos(theta);
      var y = Math.sin(phi) * Math.sin(theta);
      var z = Math.cos(phi);
      points.push({ x: x, y: y, z: z, s: 0.9 + Math.random() * 0.6 });
      if (i > 0 && Math.random() > 0.4) connections.push([i - 1, i]);
    }

    for (var r = 0; r < 18; r += 1) {
      var idx = points.length;
      var a = (r / 18) * Math.PI * 2;
      points.push({ x: Math.cos(a) * 0.92, y: Math.sin(a) * 0.92, z: 0, s: 1.1 });
      if (r > 0) connections.push([idx - 1, idx]);
      connections.push([idx, (idx + 9) % 18 + points.length - 18]);
    }

    container.addEventListener("mousemove", function (event) {
      var rect = container.getBoundingClientRect();
      mouseX = (event.clientX - rect.left) / rect.width;
      mouseY = (event.clientY - rect.top) / rect.height;
    });

    function draw() {
      ctx.clearRect(0, 0, width, height);

      var cx = width / 2;
      var cy = height / 2;
      var rotX = (mouseY - 0.5) * 1.1 + Math.sin(t * 0.1) * 0.1;
      var rotY = (mouseX - 0.5) * 1.5 + t * 0.18;
      var projected = [];

      points.forEach(function (p) {
        var cosY = Math.cos(rotY);
        var sinY = Math.sin(rotY);
        var x1 = p.x * cosY - p.z * sinY;
        var z1 = p.x * sinY + p.z * cosY;
        var cosX = Math.cos(rotX);
        var sinX = Math.sin(rotX);
        var y2 = p.y * cosX - z1 * sinX;
        var z2 = p.y * sinX + z1 * cosX;
        var scale = 310 / (1.8 + z2 * 0.6);
        projected.push({
          px: cx + x1 * scale,
          py: cy + y2 * scale,
          z: z2,
          r: p.s * (1.4 + (1 - z2) * 0.9)
        });
      });

      ctx.strokeStyle = "rgba(0,212,255,0.08)";
      ctx.lineWidth = 1;
      for (var ring = 0; ring < 6; ring += 1) {
        var ringAngle = (ring / 6) * Math.PI * 2 + t * 0.04;
        ctx.beginPath();
        for (var j = 0; j <= 36; j += 1) {
          var b = (j / 36) * Math.PI * 2;
          var px = cx + Math.cos(ringAngle) * Math.cos(b) * 290;
          var py = cy + Math.sin(b) * 290;
          if (j === 0) ctx.moveTo(px, py);
          else ctx.lineTo(px, py);
        }
        ctx.stroke();
      }

      ctx.lineWidth = 0.9;
      connections.forEach(function (pair) {
        var p1 = projected[pair[0]];
        var p2 = projected[pair[1]];
        if (!p1 || !p2) return;
        var avgZ = (p1.z + p2.z) / 2;
        var op = (0.18 + Math.max(0, avgZ) * 0.5) * 0.85;
        ctx.strokeStyle = avgZ > 0.15 ? "rgba(0,255,136," + op + ")" : "rgba(0,212,255," + op * 0.8 + ")";
        ctx.beginPath();
        ctx.moveTo(p1.px, p1.py);
        ctx.lineTo(p2.px, p2.py);
        ctx.stroke();
      });

      var coreGrad = ctx.createRadialGradient(cx, cy, 22, cx, cy, 128);
      coreGrad.addColorStop(0, "rgba(0,212,255,0.55)");
      coreGrad.addColorStop(0.3, "rgba(0,212,255,0.16)");
      coreGrad.addColorStop(1, "rgba(0,212,255,0)");
      ctx.fillStyle = coreGrad;
      ctx.beginPath();
      ctx.arc(cx, cy, 128, 0, Math.PI * 2);
      ctx.fill();

      var inner = ctx.createRadialGradient(cx - 19, cy - 23, 4, cx, cy, 42);
      inner.addColorStop(0, "rgba(255,255,255,0.95)");
      inner.addColorStop(0.4, "rgba(0,255,220,0.5)");
      inner.addColorStop(1, "transparent");
      ctx.fillStyle = inner;
      ctx.beginPath();
      ctx.arc(cx, cy, 38, 0, Math.PI * 2);
      ctx.fill();

      projected.forEach(function (p, idx) {
        var isRing = idx >= 68;
        var size = p.r * (isRing ? 0.8 : 1.1);
        var intensity = isRing ? 0.9 : 0.6 + Math.max(0, p.z) * 0.6;
        ctx.fillStyle = p.z > 0.1 ? "rgba(0,255,136," + intensity * 0.4 + ")" : "rgba(0,212,255," + intensity * 0.3 + ")";
        ctx.beginPath();
        ctx.arc(p.px, p.py, size * 1.65, 0, Math.PI * 2);
        ctx.fill();

        ctx.fillStyle = p.z > 0.1 ? "#00ff88" : "#00d4ff";
        ctx.beginPath();
        ctx.arc(p.px, p.py, size * 0.55, 0, Math.PI * 2);
        ctx.fill();
      });

      for (var f = 0; f < 5; f += 1) {
        var dataAngle = t * 0.7 + f * 1.8;
        ctx.fillStyle = "rgba(0,212,255,0.8)";
        ctx.beginPath();
        ctx.arc(cx + Math.cos(dataAngle) * 198, cy + Math.sin(dataAngle * 1.1) * 92, 1.5, 0, Math.PI * 2);
        ctx.fill();
      }

      t += 0.009;
      if (!prefersReducedMotion) window.requestAnimationFrame(draw);
    }

    draw();
  }

  function initSixAlgoChart(canvas) {
    var ctx = canvas.getContext("2d");
    if (!ctx) return;

    var w = 980;
    var h = 620;
    var priceH = 420;
    var oscY = 460;
    var oscH = 130;
    var points = [
      118, 115, 112, 108, 103, 98, 92, 88, 82, 76, 71, 68,
      74, 82, 91, 101, 112, 124, 137, 149, 158, 164, 168, 171,
      166, 160, 153, 149, 146, 143, 147, 151, 156, 162, 170, 181,
      194, 208, 222, 236, 249, 260, 266, 262, 252, 239, 224, 207,
      190, 172, 156, 143, 132, 124, 119, 116, 118, 122, 128, 134,
      139, 143, 146, 148, 150, 152, 154, 156
    ];

    var candles = [];
    for (var i = 0; i < points.length; i += 1) {
      var prev = points[Math.max(0, i - 1)];
      var close = points[i];
      var open = i === 0 ? close + 2 : prev;
      var volatility = 5 + Math.abs(close - open) * 0.28 + (i % 5);
      candles.push({
        open: open,
        close: close,
        high: Math.max(open, close) + volatility,
        low: Math.min(open, close) - volatility
      });
    }

    var max = Math.max.apply(null, candles.map(function (c) { return c.high; }));
    var min = Math.min.apply(null, candles.map(function (c) { return c.low; }));
    var chartX = 38;
    var chartW = w - 76;
    var gap = chartW / candles.length;
    var candleW = Math.max(5, gap * 0.54);

    function yFor(value) {
      return 34 + ((max - value) / (max - min)) * (priceH - 76);
    }

    ctx.clearRect(0, 0, w, h);
    ctx.fillStyle = "#050709";
    ctx.fillRect(0, 0, w, h);

    ctx.strokeStyle = "rgba(255,255,255,0.055)";
    ctx.lineWidth = 1;
    for (var gx = 0; gx <= 12; gx += 1) {
      var x = chartX + (chartW / 12) * gx;
      ctx.beginPath();
      ctx.moveTo(x, 0);
      ctx.lineTo(x, h);
      ctx.stroke();
    }
    for (var gy = 0; gy <= 8; gy += 1) {
      var y = 30 + gy * 50;
      ctx.beginPath();
      ctx.moveTo(0, y);
      ctx.lineTo(w, y);
      ctx.stroke();
    }

    candles.forEach(function (c, index) {
      var cx = chartX + index * gap + gap / 2;
      var up = c.close >= c.open;
      var top = yFor(Math.max(c.open, c.close));
      var bottom = yFor(Math.min(c.open, c.close));
      var body = Math.max(3, bottom - top);
      var color = up ? "#19b7a4" : "#ff4058";

      ctx.strokeStyle = up ? "rgba(25,183,164,0.78)" : "rgba(255,64,88,0.78)";
      ctx.beginPath();
      ctx.moveTo(cx, yFor(c.high));
      ctx.lineTo(cx, yFor(c.low));
      ctx.stroke();

      ctx.fillStyle = color;
      ctx.fillRect(cx - candleW / 2, top, candleW, body);
    });

    function drawSignal(index, type, label) {
      var c = candles[index];
      var sx = chartX + index * gap + gap / 2;
      var sy = type === "buy" ? yFor(c.low) + 24 : yFor(c.high) - 24;
      var color = type === "buy" ? "#00ff88" : "#ff4058";

      ctx.fillStyle = color;
      ctx.beginPath();
      if (type === "buy") {
        ctx.moveTo(sx, sy - 15);
        ctx.lineTo(sx - 10, sy + 8);
        ctx.lineTo(sx + 10, sy + 8);
      } else {
        ctx.moveTo(sx, sy + 15);
        ctx.lineTo(sx - 10, sy - 8);
        ctx.lineTo(sx + 10, sy - 8);
      }
      ctx.closePath();
      ctx.fill();

      ctx.fillStyle = "rgba(0,0,0,0.78)";
      ctx.fillRect(sx + 14, sy - 17, 106, 30);
      ctx.strokeStyle = "rgba(255,255,255,0.14)";
      ctx.strokeRect(sx + 14, sy - 17, 106, 30);
      ctx.fillStyle = "#ffffff";
      ctx.font = "800 11px Inter, Arial, sans-serif";
      ctx.fillText(label, sx + 23, sy + 2);
    }

    drawSignal(11, "buy", "L ZONE");
    drawSignal(43, "sell", "S ZONE");

    ctx.strokeStyle = "rgba(255,255,255,0.12)";
    ctx.beginPath();
    ctx.moveTo(0, oscY - 18);
    ctx.lineTo(w, oscY - 18);
    ctx.stroke();

    ctx.fillStyle = "rgba(255,255,255,0.82)";
    ctx.font = "800 14px Inter, Arial, sans-serif";
    ctx.fillText("Six Algo Oscillator", 28, oscY + 12);
    ctx.fillStyle = "rgba(255,255,255,0.38)";
    ctx.font = "12px Inter, Arial, sans-serif";
    ctx.fillText("No repaint - no lag - no delayed signals", 28, oscY + 32);

    ctx.setLineDash([6, 6]);
    ctx.strokeStyle = "rgba(255,64,88,0.38)";
    ctx.beginPath();
    ctx.moveTo(0, oscY + 34);
    ctx.lineTo(w, oscY + 34);
    ctx.stroke();
    ctx.strokeStyle = "rgba(255,255,255,0.24)";
    ctx.beginPath();
    ctx.moveTo(0, oscY + oscH / 2);
    ctx.lineTo(w, oscY + oscH / 2);
    ctx.stroke();
    ctx.strokeStyle = "rgba(0,255,136,0.38)";
    ctx.beginPath();
    ctx.moveTo(0, oscY + oscH - 24);
    ctx.lineTo(w, oscY + oscH - 24);
    ctx.stroke();
    ctx.setLineDash([]);

    var osc = candles.map(function (c, index) {
      var momentum = c.close - candles[Math.max(0, index - 5)].close;
      var value = Math.max(-1, Math.min(1, momentum / 42));
      return { x: chartX + index * gap + gap / 2, y: oscY + oscH / 2 - value * 46, value: value };
    });

    ctx.lineWidth = 3;
    for (var p = 1; p < osc.length; p += 1) {
      var a = osc[p - 1];
      var b = osc[p];
      ctx.strokeStyle = b.value > 0.58 ? "#ff4058" : b.value < -0.58 ? "#00ff88" : "rgba(154,165,177,0.92)";
      ctx.beginPath();
      ctx.moveTo(a.x, a.y);
      ctx.lineTo(b.x, b.y);
      ctx.stroke();
    }

    [11, 43].forEach(function (idx) {
      var point = osc[idx];
      ctx.fillStyle = idx === 11 ? "#00ff88" : "#ff4058";
      ctx.fillRect(point.x - 4, point.y - 30, 8, 60);
    });
  }

  function initReviewSlider(root) {
    var viewport = root;
    var track = viewport.querySelector("[data-review-track]");
    var section = viewport.closest(".reviews-section");
    if (!track || !section) return;
    var prev = section.querySelector("[data-review-prev]");
    var next = section.querySelector("[data-review-next]");
    var index = 0;

    function visibleCount() {
      return window.innerWidth < 761 ? 1 : 3;
    }

    function update() {
      var cards = track.children.length;
      var max = Math.max(0, cards - visibleCount());
      index = Math.max(0, Math.min(index, max));
      var card = track.children[0];
      if (!card) return;
      var offset = card.getBoundingClientRect().width + 14;
      track.style.transform = "translateX(" + (-index * offset) + "px)";
    }

    if (prev) prev.addEventListener("click", function () { index -= 1; update(); });
    if (next) next.addEventListener("click", function () { index += 1; update(); });
    window.addEventListener("resize", update);
    update();
  }

  function initAccordions() {
    document.querySelectorAll("details").forEach(function (details, index) {
      var summary = details.querySelector("summary");
      if (!summary) return;

      var contentNodes = Array.prototype.slice.call(details.children).filter(function (child) {
        return child !== summary;
      });
      var panelId = details.id || "tvalgo-accordion-" + index;
      details.id = panelId;
      summary.setAttribute("role", "button");
      summary.setAttribute("aria-expanded", String(details.open));
      summary.setAttribute("aria-controls", panelId + "-content");

      contentNodes.forEach(function (node) {
        if (!node.id) node.id = panelId + "-content";
      });

      details.addEventListener("toggle", function () {
        summary.setAttribute("aria-expanded", String(details.open));
      });
    });
  }

  function productJsonUrl(productUrl) {
    var link = document.createElement("a");
    link.href = productUrl;
    var cleanPath = link.pathname.replace(/\/$/, "");
    if (!cleanPath) cleanPath = productUrl.replace(/\/$/, "");
    return cleanPath + ".js";
  }

  function initTradingViewModal() {
    var modal = document.querySelector("[data-tv-modal]");
    if (!modal) return;

    var form = modal.querySelector("[data-tv-username-form]");
    var usernameInput = modal.querySelector("[data-tv-username-input]");
    var error = modal.querySelector("[data-tv-modal-error]");
    var productInput = modal.querySelector("[data-tv-product-url]");
    var planInput = modal.querySelector("[data-tv-plan-name]");
    var submit = modal.querySelector("[data-tv-submit]");
    var lastFocus = null;

    function openModal(productUrl, planName) {
      lastFocus = document.activeElement;
      modal.hidden = false;
      modal.classList.remove("is-loading");
      productInput.value = productUrl || "/products/bronze-all-6-tools-daily-access";
      planInput.value = planName || "TVALGO Access";
      usernameInput.value = "";
      error.hidden = true;
      submit.textContent = "Continue to Checkout";
      window.setTimeout(function () { usernameInput.focus(); }, 30);
    }

    function closeModal() {
      modal.hidden = true;
      modal.classList.remove("is-loading");
      if (lastFocus && typeof lastFocus.focus === "function") lastFocus.focus();
    }

    document.querySelectorAll("[data-plan-trigger]").forEach(function (trigger) {
      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        openModal(trigger.getAttribute("data-product-url"), trigger.getAttribute("data-plan-name"));
      });
    });

    modal.querySelectorAll("[data-tv-modal-close]").forEach(function (closer) {
      closer.addEventListener("click", closeModal);
    });

    document.addEventListener("keydown", function (event) {
      if (!modal.hidden && event.key === "Escape") closeModal();
    });

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      var username = usernameInput.value.trim();
      var productUrl = productInput.value || "/products/bronze-all-6-tools-daily-access";
      var planName = planInput.value || "TVALGO Access";

      if (!username) {
        error.hidden = false;
        usernameInput.focus();
        return;
      }

      error.hidden = true;
      modal.classList.add("is-loading");
      submit.textContent = "Preparing checkout...";

      if (location.hostname === "127.0.0.1" || location.protocol === "file:") {
        window.__tvalgoPreviewCheckout = { productUrl: productUrl, planName: planName, tradingViewUsername: username };
        submit.textContent = "Preview saved";
        window.setTimeout(closeModal, 650);
        return;
      }

      fetch(productJsonUrl(productUrl), { credentials: "same-origin" })
        .then(function (response) {
          if (!response.ok) throw new Error("Product not found");
          return response.json();
        })
        .then(function (product) {
          var variant = (product.variants || []).find(function (item) { return item.available; }) || (product.variants || [])[0];
          if (!variant) throw new Error("No variant available");

          return fetch("/cart/add.js", {
            method: "POST",
            credentials: "same-origin",
            headers: { "Content-Type": "application/json", "Accept": "application/json" },
            body: JSON.stringify({
              id: variant.id,
              quantity: 1,
              properties: {
                "TradingView username": username,
                "TVALGO plan": planName
              }
            })
          });
        })
        .then(function (response) {
          if (!response.ok) throw new Error("Could not add plan to cart");
          window.location.href = "/checkout";
        })
        .catch(function () {
          modal.classList.remove("is-loading");
          submit.textContent = "Continue to Checkout";
          error.textContent = "We could not prepare checkout. Please try again or open the product page.";
          error.hidden = false;
        });
    });
  }

  document.querySelectorAll("[data-original-ai-core]").forEach(initOriginalCore);
  document.querySelectorAll("[data-six-algo-chart]").forEach(initSixAlgoChart);
  document.querySelectorAll("[data-review-viewport]").forEach(initReviewSlider);
  initAccordions();
  initTradingViewModal();
}());
